module.exports = __webpack_public_path__ + "img/icon-products-magento-66.5a012f01.svg";